<template>
    <div class="wrap-realitation">
        <div class="wrap-content">
            <div class="title-page">Realization</div>
            <div class="content">
                <div class="wrap-realitation">
                    <div class="realitation">
                        <span>Series No</span>
                        <span>{{ getRealitation.seri }}</span>
                    </div>
                    <div class="realitation">
                        <span>HS Code</span>
                        <span>{{ getRealitation.hs }}</span>
                    </div>
                    <div class="realitation">
                        <span>Permission Id</span>
                        <span>{{ getRealitation.id_ijin }}</span>
                    </div>
                    <div class="realitation">
                        <span>Destination Code</span>
                        <span>{{ getRealitation.pelabuhan_tujuan }}</span>
                    </div>
                    <div class="realitation">
                        <span>Original State</span>
                        <span>{{ getRealitation.negara_asal }}</span>
                    </div>
                    <div class="realitation">
                        <span>Volume</span>
                        <span v-if="getRealitation.volume">{{ checkDecimal(getRealitation.volume.total) }}</span>
                    </div>
                    <div class="realitation">
                        <span>Remaining Volume</span>
                        <span v-if="getRealitation.volume">{{ getRealitation.volume.sisa.toFixed(5) }}</span>
                    </div>
                    <div class="realitation">
                        <span>Unit</span>
                        <span>{{ getRealitation.satuan }}</span>
                    </div>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th>Owner</th>
                            <th scope="col">Dimension(mm<sup>3</sup>)</th>
                            <th scope="col">Fineness</th>
                            <th scope="col">Hallmark</th>
                            <th scope="col">Weight (gr)</th>
                            <th scope="col">Serial Number</th>
                            <th scope="col">Year</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(dataMetal, index) in getMetals" :key="index" v-show="getMetals.length > 0">
                            <td>
                                <input type="checkbox" name="" :value="dataMetal._id" v-model="metalDataRealizes" @input="addMetalRealized(dataMetal._id, $event)" />
                            </td>
                            <td>{{ dataMetal.owner }}</td>
                            <td>{{ dataMetal.dimension }}</td>
                            <td>{{ dataMetal.fineness }}</td>
                            <td>{{ dataMetal.hallmark }}</td>
                            <td>{{ dataMetal.weight }}</td>
                            <td>{{ dataMetal.serial_number }}</td>
                            <td>{{ dataMetal.year }}</td>
                        </tr>
                        <tr>
                            <td colspan="8" v-show="getMetals.length == 0">Data Not Found</td>
                        </tr>
                    </tbody>
                </table>
                <div class="d-flex justify-content-end mt-3">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRealitationsData"
                        :per-page="perPage"
                        @change="handlePageChange"
                        aria-controls="new-table"
                        first-number
                        last-number
                        v-show="totalRealitationsData > 10"
                    ></b-pagination>
                </div>

                <div class="wrap-button" v-if="getMetals.length > 0">
                    <button type="button" class="btn btn-submit" @click="openModal" :disabled="metalDataRealizes.length == 0">Realization</button>
                </div>

                <b-modal ref="choose-doc-modal" size="lg" title="Choose Document PPFTZ">
                    <div class="form-group">
                        <label for="">Choose Document PPFTZ</label>
                        <select name="" id="" v-model="selectedDoc" @change="setSelectedDoc" class="form-input">
                            <option value="" disabled selected>Choose Documen</option>
                            <option v-for="(docData, i) in documentDatas" :key="i" :value="{ id: docData._id, file: docData.file }">
                                <div class="description-doc">{{ docData.doc_no }} / {{ docData.description }}</div>
                            </option>
                        </select>

                        <div v-if="selectedDoc.file != ''" class="text-center">
                            <b-spinner label="Loading..." v-if="isLoadingPreview"></b-spinner>
                            <pdf v-for="i in numPages" :key="i" :src="src" :page="i" v-else />
                        </div>
                    </div>
                    <template #modal-footer>
                        <div class="wrap-button">
                            <button type="button" class="btn btn-scondary" @click="submitRealitation">
                                <b-spinner v-if="isLoadingSubmit" small></b-spinner>
                                <span v-else>Submit</span>
                            </button>
                        </div>
                    </template>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import pdf from "vue-pdf";
export default {
    components: {
        pdf,
    },
    data() {
        return {
            metalDatas: [],
            totalRealitationsData: "",
            metalDataRealizes: [],
            documentDatas: [],
            isLoadingPreview: false,
            numPages: undefined,
            isLoadingSubmit: false,
            startDate: "",
            endDate: "",
            perPage: 10,
            currentPage: 1,
            src: null,
            selectedDoc: {
                id: "",
                file: "",
            },
        };
    },
    mounted() {
        axios.get("/v2/clearing/admin/abx/get/list_document").then((res) => {
            this.documentDatas = res.data.data.data;
        });
        this.getData(this.startDate, this.endDate, this.perPage, this.currentPage);
    },
    computed: {
        getMetals() {
            return this.$store.state.vaultModul.realisationDatas.metal;
        },
        getRealitation() {
            return this.$store.state.vaultModul.realisationDatas.realisasi;
        },
        getTotalRealitation() {
            return this.$store.state.vaultModul.realisationDatas.count;
        },
    },
    methods: {
        checkDecimal(value) {
            if (Number.isInteger(value)) {
                return value;
            } else {
                let lengthDecimal = value.toString().split(".")[1].length;
                let newValue;
                if (lengthDecimal > 5) {
                    newValue = value.toFixed(5);
                } else {
                    newValue = value;
                }
                return newValue;
            }
        },
        handlePageChange(value) {
            this.getData(this.startDate, this.endDate, this.perPage, value);
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
        getData(startDate, endDate, perPage, currentPage) {
            let id = this.$route.params.id;
            let seri = this.$route.params.seri;
            this.$store.dispatch("getRealisation", { id, seri, startDate, endDate, currentPage, perPage });
        },
        submitRealitation() {
            this.isLoadingSubmit = true;
            let data = {
                realisasi_id: this.getRealitation._id,
                document_id: this.selectedDoc.id,
                metal_id: this.metalDataRealizes,
            };
            axios
                .post("/v2/clearing/admin/abx/send_realisasi", data)
                .then((res) => {
                    if (!res.data.data.iserror) {
                        this.$toast.success("Submit Realization Success");
                        setTimeout(() => {
                            location.reload();
                        }, 2000);
                    }
                })
                .catch((error) => {
                    this.isLoadingSubmit = false;
                    this.$toast.error(error.response.data.data.err_message);
                });
        },
        setSelectedDoc() {
            this.isLoadingPreview = true;
            let newFile = this.selectedDoc.file;
            this.getImage(newFile)
                .then((res) => {
                    this.isLoadingPreview = false;
                    this.src = pdf.createLoadingTask(res);
                    this.src.promise.then((pdf) => {
                        this.numPages = pdf.numPages;
                    });
                })
                .catch(() => {
                    this.isLoadingPreview = false;
                });
        },
        async getImage(file) {
            let image = await axios.get("/v2/" + file, { responseType: "blob" });
            image = URL.createObjectURL(new Blob([image.data], { type: image.data.type }));
            return image;
        },
        openModal() {
            this.selectedDoc.file = "";
            this.$refs["choose-doc-modal"].show();
        },
        addMetalRealized(metal_id, event) {
            if (event.target.checked) {
                this.metalDataRealizes.push(metal_id);
            } else {
                this.metalDataRealizes.splice(this.metalDataRealizes.indexOf(metal_id), 1);
            }
        },
    },
};
</script>

<style scoped>
.title-page {
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 40px;
}

.wrap-realitation {
    margin-bottom: 2rem;
}

.realitation {
    display: flex;
    margin-bottom: 0.5rem;
}

.realitation span:first-child {
    width: 9rem;
}
.realitation span:last-child {
    font-weight: 600;
}

.wrap-button {
    margin-top: 2rem;
    text-align: right;
}

.btn-submit {
    background: var(--clr-primary);
    color: #fff;
}

.btn-scondary {
    background: var(--clr-scondary);
    color: #fff;
}

.form-input {
    width: 100%;
    border-radius: 5px;
    border: 0.5px solid rgb(50 50 93 / 15%);
    padding: 0.75rem 1rem;
    box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
}

button:disabled {
    cursor: not-allowed;
}
</style>
